var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStackedareachartThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 975,
    height: 785,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "full",
    viewBox: "0 0 975 785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 975,
    height: 785,
    x: 0,
    y: 0,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 741.5L936 741.5",
    fill: "none",
    stroke: "#E0E6F1",
    className: "zr0-cls-0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 628.5L936 628.5",
    fill: "none",
    stroke: "#E0E6F1",
    className: "zr0-cls-0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 514.5L936 514.5",
    fill: "none",
    stroke: "#E0E6F1",
    className: "zr0-cls-0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 400.5L936 400.5",
    fill: "none",
    stroke: "#E0E6F1",
    className: "zr0-cls-0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 287.5L936 287.5",
    fill: "none",
    stroke: "#E0E6F1",
    className: "zr0-cls-0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 173.5L936 173.5",
    fill: "none",
    stroke: "#E0E6F1",
    className: "zr0-cls-0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 60.5L936 60.5",
    fill: "none",
    stroke: "#E0E6F1",
    className: "zr0-cls-0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 741.5L936 741.5",
    fill: "none",
    stroke: "#6E7079",
    strokeLinecap: "round",
    className: "zr0-cls-0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 741.45L67.5 746.45",
    fill: "none",
    stroke: "#6E7079",
    className: "zr0-cls-0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M212.5 741.45L212.5 746.45",
    fill: "none",
    stroke: "#6E7079",
    className: "zr0-cls-0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M357.5 741.45L357.5 746.45",
    fill: "none",
    stroke: "#6E7079",
    className: "zr0-cls-0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M501.5 741.45L501.5 746.45",
    fill: "none",
    stroke: "#6E7079",
    className: "zr0-cls-0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 741.45L646.5 746.45",
    fill: "none",
    stroke: "#6E7079",
    className: "zr0-cls-0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M791.5 741.45L791.5 746.45",
    fill: "none",
    stroke: "#6E7079",
    className: "zr0-cls-0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M936.5 741.45L936.5 746.45",
    fill: "none",
    stroke: "#6E7079",
    className: "zr0-cls-0"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(59.2793 741.45)",
    fill: "#6E7079"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(59.2793 627.875)",
    fill: "#6E7079"
  }, "500"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(59.2793 514.3)",
    fill: "#6E7079"
  }, "1,000"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(59.2793 400.725)",
    fill: "#6E7079"
  }, "1,500"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(59.2793 287.15)",
    fill: "#6E7079"
  }, "2,000"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(59.2793 173.575)",
    fill: "#6E7079"
  }, "2,500"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(59.2793 60)",
    fill: "#6E7079"
  }, "3,000"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(67.2793 749.45)",
    fill: "#6E7079"
  }, "Mon"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(212.0661 749.45)",
    fill: "#6E7079"
  }, "Tue"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(356.8529 749.45)",
    fill: "#6E7079"
  }, "Wed"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(501.6396 749.45)",
    fill: "#6E7079"
  }, "Thu"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(646.4264 749.45)",
    fill: "#6E7079"
  }, "Fri"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(791.2132 749.45)",
    fill: "#6E7079"
  }, "Sat"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(936 749.45)",
    fill: "#6E7079"
  }, "Sun"), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr0-c0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 714.192L212.0661 711.4662L356.8529 718.5079L501.6396 711.0119L646.4265 721.0065L791.2132 689.2055L936 693.7485L936 741.45L791.2132 741.45L646.4265 741.45L501.6396 741.45L356.8529 741.45L212.0661 741.45L67.2793 741.45Z",
    fill: "rgb(84,112,198)",
    fillOpacity: 0.7,
    className: "zr0-cls-2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr0-c1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 664.219L212.0661 670.1249L356.8529 675.1222L501.6396 657.8588L646.4265 655.133L791.2132 614.246L936 623.332L936 693.7485L791.2132 689.2055L646.4265 721.0065L501.6396 711.0119L356.8529 718.5079L212.0661 711.4662L67.2793 714.192Z",
    fill: "rgb(145,204,117)",
    fillOpacity: 0.7,
    className: "zr0-cls-3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr0-c2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 630.1465L212.0661 617.4261L356.8529 629.465L501.6396 622.8777L646.4265 611.9745L791.2132 539.2865L936 530.2005L936 623.332L791.2132 614.246L646.4265 655.133L501.6396 657.8588L356.8529 675.1222L212.0661 670.1249L67.2793 664.219Z",
    fill: "rgb(250,200,88)",
    fillOpacity: 0.7,
    className: "zr0-cls-4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr0-c3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 557.4585L212.0661 542.0123L356.8529 561.0929L501.6396 547.0096L646.4265 523.386L791.2132 464.327L936 457.5125L936 530.2005L791.2132 539.2865L646.4265 611.9745L501.6396 622.8777L356.8529 629.465L212.0661 617.4261L67.2793 630.1465Z",
    fill: "rgb(238,102,102)",
    fillOpacity: 0.7,
    className: "zr0-cls-5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr0-c4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 371.1955L212.0661 330.3085L356.8529 356.4308L501.6396 334.8515L646.4265 230.3625L791.2132 162.2175L936 157.6745L936 457.5125L791.2132 464.327L646.4265 523.386L501.6396 547.0096L356.8529 561.0929L212.0661 542.0123L67.2793 557.4585Z",
    fill: "rgb(115,192,222)",
    fillOpacity: 0.7,
    className: "zr0-cls-6"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr0-c0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 714.192L212.0661 711.4662L356.8529 718.5079L501.6396 711.0119L646.4265 721.0065L791.2132 689.2055L936 693.7485",
    fill: "none",
    stroke: "rgb(84,112,198)",
    strokeWidth: 2,
    strokeLinejoin: "bevel",
    className: "zr0-cls-7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr0-c1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 664.219L212.0661 670.1249L356.8529 675.1222L501.6396 657.8588L646.4265 655.133L791.2132 614.246L936 623.332",
    fill: "none",
    stroke: "rgb(145,204,117)",
    strokeWidth: 2,
    strokeLinejoin: "bevel",
    className: "zr0-cls-7"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr0-c2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 630.1465L212.0661 617.4261L356.8529 629.465L501.6396 622.8777L646.4265 611.9745L791.2132 539.2865L936 530.2005",
    fill: "none",
    stroke: "rgb(250,200,88)",
    strokeWidth: 2,
    strokeLinejoin: "bevel",
    className: "zr0-cls-7"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr0-c3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 557.4585L212.0661 542.0123L356.8529 561.0929L501.6396 547.0096L646.4265 523.386L791.2132 464.327L936 457.5125",
    fill: "none",
    stroke: "rgb(238,102,102)",
    strokeWidth: 2,
    strokeLinejoin: "bevel",
    className: "zr0-cls-7"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr0-c4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2793 371.1955L212.0661 330.3085L356.8529 356.4308L501.6396 334.8515L646.4265 230.3625L791.2132 162.2175L936 157.6745",
    fill: "none",
    stroke: "rgb(115,192,222)",
    strokeWidth: 2,
    strokeLinejoin: "bevel",
    className: "zr0-cls-7"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,67.2793,714.192)",
    fill: "rgb(255,255,255)",
    stroke: "#5470c6",
    className: "zr0-cls-8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,212.0661,711.4662)",
    fill: "#fff",
    stroke: "#5470c6",
    className: "zr0-cls-8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,356.8529,718.5079)",
    fill: "#fff",
    stroke: "#5470c6",
    className: "zr0-cls-8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,501.6396,711.0119)",
    fill: "#fff",
    stroke: "#5470c6",
    className: "zr0-cls-8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,646.4265,721.0065)",
    fill: "#fff",
    stroke: "#5470c6",
    className: "zr0-cls-8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,791.2132,689.2055)",
    fill: "#fff",
    stroke: "#5470c6",
    className: "zr0-cls-8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,936,693.7485)",
    fill: "#fff",
    stroke: "#5470c6",
    className: "zr0-cls-8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,67.2793,664.219)",
    fill: "rgb(255,255,255)",
    stroke: "#91cc75",
    className: "zr0-cls-8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,212.0661,670.1249)",
    fill: "#fff",
    stroke: "#91cc75",
    className: "zr0-cls-8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,356.8529,675.1222)",
    fill: "#fff",
    stroke: "#91cc75",
    className: "zr0-cls-8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,501.6396,657.8588)",
    fill: "#fff",
    stroke: "#91cc75",
    className: "zr0-cls-8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,646.4265,655.133)",
    fill: "#fff",
    stroke: "#91cc75",
    className: "zr0-cls-8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,791.2132,614.246)",
    fill: "#fff",
    stroke: "#91cc75",
    className: "zr0-cls-8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,936,623.332)",
    fill: "#fff",
    stroke: "#91cc75",
    className: "zr0-cls-8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,67.2793,630.1465)",
    fill: "rgb(255,255,255)",
    stroke: "#fac858",
    className: "zr0-cls-8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,212.0661,617.4261)",
    fill: "#fff",
    stroke: "#fac858",
    className: "zr0-cls-8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,356.8529,629.465)",
    fill: "#fff",
    stroke: "#fac858",
    className: "zr0-cls-8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,501.6396,622.8777)",
    fill: "#fff",
    stroke: "#fac858",
    className: "zr0-cls-8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,646.4265,611.9745)",
    fill: "#fff",
    stroke: "#fac858",
    className: "zr0-cls-8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,791.2132,539.2865)",
    fill: "#fff",
    stroke: "#fac858",
    className: "zr0-cls-8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,936,530.2005)",
    fill: "#fff",
    stroke: "#fac858",
    className: "zr0-cls-8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,67.2793,557.4585)",
    fill: "rgb(255,255,255)",
    stroke: "#ee6666",
    className: "zr0-cls-8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,212.0661,542.0123)",
    fill: "#fff",
    stroke: "#ee6666",
    className: "zr0-cls-8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,356.8529,561.0929)",
    fill: "#fff",
    stroke: "#ee6666",
    className: "zr0-cls-8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,501.6396,547.0096)",
    fill: "#fff",
    stroke: "#ee6666",
    className: "zr0-cls-8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,646.4265,523.386)",
    fill: "#fff",
    stroke: "#ee6666",
    className: "zr0-cls-8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,791.2132,464.327)",
    fill: "#fff",
    stroke: "#ee6666",
    className: "zr0-cls-8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,936,457.5125)",
    fill: "#fff",
    stroke: "#ee6666",
    className: "zr0-cls-8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,67.2793,371.1955)",
    fill: "rgb(255,255,255)",
    stroke: "#73c0de",
    className: "zr0-cls-8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,212.0661,330.3085)",
    fill: "#fff",
    stroke: "#73c0de",
    className: "zr0-cls-8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,356.8529,356.4308)",
    fill: "#fff",
    stroke: "#73c0de",
    className: "zr0-cls-8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,501.6396,334.8515)",
    fill: "#fff",
    stroke: "#73c0de",
    className: "zr0-cls-8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,646.4265,230.3625)",
    fill: "#fff",
    stroke: "#73c0de",
    className: "zr0-cls-8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,791.2132,162.2175)",
    fill: "#fff",
    stroke: "#73c0de",
    className: "zr0-cls-8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,936,157.6745)",
    fill: "#fff",
    stroke: "#73c0de",
    className: "zr0-cls-8"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: -6,
    transform: "translate(67.2793 363.1955)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "820"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: -6,
    transform: "translate(212.0661 322.3085)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "932"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: -6,
    transform: "translate(356.8529 348.4308)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "901"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: -6,
    transform: "translate(501.6396 326.8515)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "934"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: -6,
    transform: "translate(646.4265 222.3625)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "1290"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: -6,
    transform: "translate(791.2132 154.2175)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "1330"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: -6,
    transform: "translate(936 149.6745)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "1320"), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5l454.9199 0l0 23.2l-454.9199 0Z",
    transform: "translate(265.04 5)",
    fill: "rgb(0,0,0)",
    fillOpacity: 0,
    stroke: "#ccc",
    strokeWidth: 0,
    className: "zr0-cls-0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7L25 7",
    transform: "translate(266.04 4.6)",
    fill: "#000",
    stroke: "#5470c6",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    className: "zr0-cls-0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 7A5.6 5.6 0 1 1 18.1 6.9994",
    transform: "translate(266.04 4.6)",
    fill: "#fff",
    stroke: "#5470c6",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    className: "zr0-cls-0"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 30,
    y: 7,
    transform: "translate(266.04 4.6)",
    fill: "#333"
  }, "Email"), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 0.4l61.0059 0l0 13.2l-61.0059 0Z",
    transform: "translate(266.04 4.6)",
    fill: "none",
    className: "zr0-cls-9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7L25 7",
    transform: "translate(337.0459 4.6)",
    fill: "#000",
    stroke: "#91cc75",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    className: "zr0-cls-0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 7A5.6 5.6 0 1 1 18.1 6.9994",
    transform: "translate(337.0459 4.6)",
    fill: "#fff",
    stroke: "#91cc75",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    className: "zr0-cls-0"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    xmlSpace: "preserve",
    x: 30,
    y: 7,
    transform: "translate(337.0459 4.6)",
    fill: "#333"
  }, "Union Ads"), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 0.4l86.3652 0l0 13.2l-86.3652 0Z",
    transform: "translate(337.0459 4.6)",
    fill: "none",
    className: "zr0-cls-9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7L25 7",
    transform: "translate(433.4111 4.6)",
    fill: "#000",
    stroke: "#fac858",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    className: "zr0-cls-0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 7A5.6 5.6 0 1 1 18.1 6.9994",
    transform: "translate(433.4111 4.6)",
    fill: "#fff",
    stroke: "#fac858",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    className: "zr0-cls-0"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    xmlSpace: "preserve",
    x: 30,
    y: 7,
    transform: "translate(433.4111 4.6)",
    fill: "#333"
  }, "Video Ads"), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 0.4l85.4922 0l0 13.2l-85.4922 0Z",
    transform: "translate(433.4111 4.6)",
    fill: "none",
    className: "zr0-cls-9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7L25 7",
    transform: "translate(528.9033 4.6)",
    fill: "#000",
    stroke: "#ee6666",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    className: "zr0-cls-0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 7A5.6 5.6 0 1 1 18.1 6.9994",
    transform: "translate(528.9033 4.6)",
    fill: "#fff",
    stroke: "#ee6666",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    className: "zr0-cls-0"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 30,
    y: 7,
    transform: "translate(528.9033 4.6)",
    fill: "#333"
  }, "Direct"), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 0.4l62.3359 0l0 13.2l-62.3359 0Z",
    transform: "translate(528.9033 4.6)",
    fill: "none",
    className: "zr0-cls-9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7L25 7",
    transform: "translate(601.2393 4.6)",
    fill: "#000",
    stroke: "#73c0de",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    className: "zr0-cls-0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 7A5.6 5.6 0 1 1 18.1 6.9994",
    transform: "translate(601.2393 4.6)",
    fill: "#fff",
    stroke: "#73c0de",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    className: "zr0-cls-0"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    xmlSpace: "preserve",
    x: 30,
    y: 7,
    transform: "translate(601.2393 4.6)",
    fill: "#333"
  }, "Search Engine"), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 0.4l109.7207 0l0 13.2l-109.7207 0Z",
    transform: "translate(601.2393 4.6)",
    fill: "none",
    className: "zr0-cls-9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5l176.0693 0l0 28l-176.0693 0Z",
    transform: "translate(5 5)",
    fill: "rgb(0,0,0)",
    fillOpacity: 0,
    stroke: "#ccc",
    strokeWidth: 0,
    className: "zr0-cls-0"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 18,
      fontFamily: "sans-serif",
      fontWeight: "bold"
    },
    xmlSpace: "preserve",
    y: 9,
    transform: "translate(5 5)",
    fill: "#464646"
  }, "Stacked Area Chart"), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zr0-c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 59l872 0l0 683.45l-872 0Z",
    fill: "#000",
    className: "zr0-cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zr0-c1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 59l872 0l0 683.45l-872 0Z",
    fill: "#000",
    className: "zr0-cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zr0-c2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 59l872 0l0 683.45l-872 0Z",
    fill: "#000",
    className: "zr0-cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zr0-c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 59l872 0l0 683.45l-872 0Z",
    fill: "#000",
    className: "zr0-cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zr0-c4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 59l872 0l0 683.45l-872 0Z",
    fill: "#000",
    className: "zr0-cls-1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedareachartThumb);
export default __webpack_public_path__ + "static/media/stackedareachart_thumb.46af428d7a2a8b446fe182e1908d80d5.svg";
export { ForwardRef as ReactComponent };